module.exports = __webpack_public_path__ + "img/slika62.ae87bcea.jpg";